import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'localization';
import { setSphereId } from '@center-pwa/reducers/sphereReducer';
import MetaspaceContent from '../../MetaspaceContent/MetaspaceContent';

const NOOP = () => {
  /* MetaspaceContent requires this prop; settings shell owns metaspace selection so updates are ignored */
};

const MembersSection: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { orgId } = useParams<{ orgId: string }>();

  // Scope the Redux sphere to the org named in the URL so MetaspaceContent
  // renders in the correct sphere context.
  useEffect(() => {
    if (!orgId) return;
    dispatch(setSphereId({ sphereId: orgId, source: 'MembersSection' }));
  }, [orgId, dispatch]);

  if (!orgId) {
    return (
      <div className="org-settings-section" role="status">
        {t('orgSettings.members.noOrg')}
      </div>
    );
  }

  return (
    <div className="members-section" data-testid="members-section">
      <MetaspaceContent
        metaspaceId="center_user_management_metaspace"
        onMetaspaceIdChange={NOOP}
      />
    </div>
  );
};

export default MembersSection;
